import { KpiBar } from '@arnold/common';
import { useTranslation } from 'react-i18next';
import { metricDisplay, type CustomMetricSummary } from '@arnold/core';
import { formatMetricNumber } from './formatMetricNumber';
import type { MetricFormat } from './types';

export function MetricValue({
  summary,
  format,
  bar = true,
}: {
  summary?: CustomMetricSummary;
  format: MetricFormat;
  bar?: boolean;
}) {
  const { i18n } = useTranslation('newReport');
  if (!summary || summary.value === undefined) return <span>—</span>;
  const display = metricDisplay(summary, format);
  return (
    <div style={{ minWidth: 0, width: '100%' }}>
      <strong>
        {formatMetricNumber(
          display.value!,
          i18n.language,
          summary.nps ? 'integer' : summary.scale ? 'scale' : undefined,
        )}
        {display.suffix}
      </strong>
      {bar && display.max > display.min && (
        <KpiBar
          value={display.value!}
          min={display.min}
          max={display.max}
          variant={summary.nps ? 'nps' : 'scale'}
          state="normal"
        />
      )}
    </div>
  );
}
